<script>
  import { view } from 'modules/stores.js'

  const toSettings = () => {
    $view = 'config'
  }
</script>

<nav class=" f6 text-gray ">
  <ul class="list-style-none d-flex flex-wrap ">
    <li class="mr-3">
      <button
        type="button"
        class="btn-link"
        title="Go to settings"
        on:click|preventDefault={toSettings}>
        Settings
      </button>
    </li>
  </ul>
</nav>
